var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 22H7.6c-1.3 0-2.4-1.1-2.4-2.4v-3.4l5.1-5.1-5.1-5.2V2.4C5.2 1.1 6.3 0 7.6 0h6.8c1.3 0 2.4 1.1 2.4 2.4v3.4L11.7 11l5.1 5.1v3.4c0 1.4-1.1 2.5-2.4 2.5zm-7.8-5.3v2.9c0 .6.5 1.1 1.1 1.1h6.8c.6 0 1.1-.5 1.1-1.1v-2.9L11 12.2l-4.4 4.5zm0-11.4L11 9.8l4.4-4.4v-3c0-.6-.5-1.1-1.1-1.1H7.6c-.6.1-1 .6-1 1.1v2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.3l2.8-2.8H8.3L11 8.3zm0 7.5l3.8 4.1H7.2l3.8-4.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/Hourglass.0e8e8328.svg";
export { ForwardRef as ReactComponent };